export { default as withDataHandler } from "./withDataHandler";
export { default as withQueryParser } from "./withQueryParser";
export { default as withTooltip } from "./withTooltip";



// WEBPACK FOOTER //
// ./src/components/HOC/index.js